export default "/images/9ba9c94c107e55c695fed26e81c30957.avif";